<template>
    <div>
        <!-- 搜索 -->
        <el-row class="player-pool__search">
            <div class="item">
                <span>渠道:</span>
                <el-select v-model="searchList.channel" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>有效状态:</span>
                <el-select v-model="searchList.valid" filterable placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in validList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="getPlayerPoolConfigList(1)">搜索</el-button>
            <el-button type="success" @click="() => {
                addDialogVisible = true
                addDialogType = 0
            }">添加</el-button>
        </el-row>

        <!-- 表格 -->
        <el-row>
            <el-table border :data="playerPoolConfigList" style="width: 100%">
                <el-table-column prop="id" label="ID" align="center">
                </el-table-column>
                <el-table-column prop="eventCode" label="事件码" align="center" >
                    <template slot-scope="scope">
                        {{ eventCodeList.find(item => item.value == scope.row.eventCode)?.name || scope.row.eventCode }}
                    </template>
                </el-table-column>
                <el-table-column prop="channel" label="渠道" align="center" >
                    <template slot-scope="scope">
                        {{channelList.find(item => item.value == scope.row.channel)?.name || scope.row.channel}}
                    </template>
                </el-table-column>
                <el-table-column prop="whiteConfig" label="白名单配置" align="center">
                    <template slot-scope="scope">
                        <div>
                            <div>退出条件: {{scope.row.whiteConfig?.limit || '未设置'}}</div>
                            <div>配置数: {{scope.row.whiteConfig?.multiList?.length || 0}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="blackConfig" label="黑名单配置" align="center" >
                    <template slot-scope="scope">
                        <div>
                            <div>退出条件: {{scope.row.blackConfig?.limit || '未设置'}}</div>
                            <div>配置数: {{scope.row.blackConfig?.multiList?.length || 0}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="valid" label="是否有效" align="center" >
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.valid == 0 ? 'danger' : 'success'" size="small">
                            {{ scope.row.valid == 0 ? '无效' : '有效' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center" >
                </el-table-column>
                <el-table-column prop="mtime" :formatter="formatTime" label="修改时间" align="center" width="150">
                </el-table-column>
                <el-table-column prop="ctime" :formatter="formatTime" label="创建时间" align="center" width="150">
                </el-table-column>
                <el-table-column label="操作" align="center" >
                    <template slot-scope="scope">
                        <el-button type="primary" @click="updateDialog(scope.row)"
                            style="margin-bottom: 10px;">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit"
                @current-change="handleCurrentChange">
            </el-pagination>
        </el-row>

        <!-- 添加/编辑 -->
        <el-dialog :title="addDialogType == 0 ? '添加个人奖池配置' : '编辑个人奖池配置'" :visible.sync="addDialogVisible" width="80%"
            @close="addDialogClose">
            <el-form :model="addDialogInfo" :rules="ruleList" ref="addDialogForm" label-width="150px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="事件码" prop="eventCode">
                            <el-select v-model="addDialogInfo.eventCode" placeholder="请选择事件码" style="width: 100%;" :disabled="addDialogType === 1">
                                <el-option v-for="(item, index) in eventCodeList" :key="index" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="渠道" prop="channel">
                            <el-select v-model="addDialogInfo.channel" filterable placeholder="请选择" style="width: 100%;" :disabled="addDialogType === 1">
                                <el-option v-for="(item, index) in channelList" :key="index" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="有效状态" prop="valid">
                            <el-switch v-model="addDialogInfo.valid" :active-value="1" :inactive-value="0" active-text="有效"
                                inactive-text="无效"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 白名单配置 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>白名单奖池配置</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="白名单退出条件" prop="whiteConfig.limit">
                                <el-input v-model="addDialogInfo.whiteConfig.limit" placeholder="白名单 < limit 时退出" clearable>
                                    <template slot="prepend">白名单小于</template>
                                    <template slot="append">时, 退出</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="奖池配置列表">
                                <div style="margin-bottom: 10px;">
                                    <el-button type="primary" size="small" @click="addMultiConfig('white')">添加配置</el-button>
                                </div>
                                <el-table :data="addDialogInfo.whiteConfig.multiList" size="mini" border>
                                    <el-table-column prop="multi" label="返奖倍数" width="120">
                                        <template slot-scope="scope">
                                            <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="概率" width="120">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.rate" placeholder="概率" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="80">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="removeMultiConfig('white', scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 黑名单配置 -->
                <el-card class="form-section" shadow="never">
                    <div slot="header" class="section-header">
                        <span>黑名单奖池配置</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="黑名单退出条件" prop="blackConfig.limit">
                                <el-input v-model="addDialogInfo.blackConfig.limit" placeholder="黑名单 > limit 时退出" clearable>
                                    <template slot="prepend">黑名单大于</template>
                                    <template slot="append">时, 退出</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="奖池配置列表">
                                <div style="margin-bottom: 10px;">
                                    <el-button type="primary" size="small" @click="addMultiConfig('black')">添加配置</el-button>
                                </div>
                                <el-table :data="addDialogInfo.blackConfig.multiList" size="mini" border>
                                    <el-table-column prop="multi" label="返奖倍数" width="120">
                                        <template slot-scope="scope">
                                            <el-input-number v-model="scope.row.multi" :min="0" size="mini" style="width: 100%;"></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="概率" width="120">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.rate" placeholder="概率" size="mini"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="80">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="removeMultiConfig('black', scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
            </el-form>
            
            <!-- 操作按钮 -->
            <div style="text-align: right; margin-top: 20px;">
                <el-button @click="addDialogClose">取消</el-button>
                <el-button type="primary" @click="submitDialog">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PlayerPoolConfig',
    data() {
        return {
            searchList: {
                channel: null,
                valid: 1,
            },
            // 0:添加 1:编辑
            addDialogType: 0,
            addDialogVisible: false,
            validList: [
                {
                    value: 0,
                    label: '无效'
                },
                {
                    value: 1,
                    label: '有效'
                }
            ],
            addDialogInfo: {
                id: null,
                eventCode: 9,
                channel: null,
                whiteConfig: {
                    limit: '',
                    multiList: []
                },
                blackConfig: {
                    limit: '',
                    multiList: []
                },
                valid: 1,
                operator: ''
            },
            ruleList: {
                'eventCode': [{ required: true, message: '请选择事件码', trigger: 'change' }],
                'channel': [{ required: true, message: '请选择渠道', trigger: 'change' }],
                'whiteConfig.limit': [
                    { required: true, message: '请输入白名单退出条件', trigger: 'blur' },
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字', trigger: 'blur' }
                ],
                'blackConfig.limit': [
                    { required: true, message: '请输入黑名单退出条件', trigger: 'blur' },
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字', trigger: 'blur' }
                ],
            },
            channelList: [],
            eventCodeList: [
                { value: 9, name: '幸运礼物' }
            ],
            playerPoolConfigList: [],
            total: 0,
            page: 1,
            limit: 20
        }
    },
    mounted() {
        this.getChannelList()
        this.getPlayerPoolConfigList(1)
    },
    methods: {
        formatTime(row, column, cellValue) {
            return cellValue ? new Date(cellValue * 1000).toLocaleString() : ''
        },
        async getChannelList() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        addDialogClose() {
            this.addDialogVisible = false
            this.addDialogInfo = {
                id: null,
                eventCode: 9,
                channel: null,
                whiteConfig: {
                    limit: '',
                    multiList: []
                },
                blackConfig: {
                    limit: '',
                    multiList: []
                },
                valid: 1,
                operator: ''
            }
        },
        submitDialog() {
            this.$refs.addDialogForm.validate((valid) => {
                if (valid) {
                    if (this.addDialogType == 0) {
                        this.addPlayerPoolConfig()
                    } else {
                        this.updatePlayerPoolConfig()
                    }
                }
            });
        },
        updateDialog(info) {
            this.addDialogType = 1
            this.addDialogInfo = JSON.parse(JSON.stringify(info))
            this.addDialogVisible = true
        },
        addMultiConfig(type) {
            const newConfig = { multi: 0, rate: '' }
            if (type === 'white') {
                this.addDialogInfo.whiteConfig.multiList.push(newConfig)
            } else if (type === 'black') {
                this.addDialogInfo.blackConfig.multiList.push(newConfig)
            }
        },
        removeMultiConfig(type, index) {
            if (type === 'white') {
                this.addDialogInfo.whiteConfig.multiList.splice(index, 1)
            } else if (type === 'black') {
                this.addDialogInfo.blackConfig.multiList.splice(index, 1)
            }
        },
        handleCurrentChange(page) {
            this.getPlayerPoolConfigList(page)
        },
        async getPlayerPoolConfigList(page) {
            if (page) {
                this.page = page
            }
            const { data: res } = await this.$axios({
                method: 'get',
                url: this.$store.getters.path.pool_mgr_player_pool_config_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    eventCode: 9,
                    pageNum: this.page,
                    pageSize: this.limit,
                    ...this.searchList
                }
            })
            if (res.code === 0 || res.status === 0) {
                console.log('API返回数据:', res.data)
                if (res.data && Array.isArray(res.data.data)) {
                    this.playerPoolConfigList = res.data.data
                    this.total = res.data.total || res.data.data.length
                } else {
                    this.playerPoolConfigList = []
                    this.total = 0
                }
                console.log('处理后的个人奖池配置列表:', this.playerPoolConfigList)
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async addPlayerPoolConfig() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 数据格式转换，确保符合API要求
            this.formatDataForApi(data)
            // 添加必要的字段
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.pool_mgr_player_pool_config_create,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('添加成功')
                this.getPlayerPoolConfigList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        async updatePlayerPoolConfig() {
            const data = JSON.parse(JSON.stringify(this.addDialogInfo))
            // 数据格式转换，确保符合API要求
            this.formatDataForApi(data)
            // 添加必要的字段
            data.operator = this.$store.getters.username
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.pool_mgr_player_pool_config_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data
            })
            if (res.code === 0 || res.status === 0) {
                this.$message.success('更新成功')
                this.getPlayerPoolConfigList()
                this.addDialogClose()
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        formatDataForApi(data) {
            // 确保数字字段为数字类型
            if (data.eventCode !== null && data.eventCode !== undefined) {
                data.eventCode = parseInt(data.eventCode)
            }
            
            // 处理limit字段，确保为字符串类型
            if (data.whiteConfig && data.whiteConfig.limit !== null && data.whiteConfig.limit !== undefined) {
                data.whiteConfig.limit = String(data.whiteConfig.limit)
            }
            if (data.blackConfig && data.blackConfig.limit !== null && data.blackConfig.limit !== undefined) {
                data.blackConfig.limit = String(data.blackConfig.limit)
            }
            
            // 处理倍率配置中的数字字段
            const multiConfigFields = [
                'whiteConfig.multiList',
                'blackConfig.multiList'
            ]
            
            multiConfigFields.forEach(field => {
                const keys = field.split('.')
                let obj = data
                for (let i = 0; i < keys.length - 1; i++) {
                    obj = obj[keys[i]]
                }
                const lastKey = keys[keys.length - 1]
                if (Array.isArray(obj[lastKey])) {
                    obj[lastKey].forEach(item => {
                        if (item.multi !== null && item.multi !== undefined) {
                            item.multi = parseInt(item.multi)
                        }
                        if (item.rate === '') {
                            item.rate = null
                        }
                    })
                }
            })
            
            // 确保valid字段为数字类型
            if (data.valid !== null && data.valid !== undefined) {
                data.valid = parseInt(data.valid)
            }
        },
    }
}
</script>

<style scoped lang="scss">
.player-pool {
    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;

        .item {
            display: flex;
            align-items: center;
            width: max-content;
        }

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }
    }
}

.form-section {
    margin-bottom: 20px;
    
    .section-header {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }
}
</style>
